export function parseOccFacets( facetData ) {
  let fd = {}

  if ( facetData ) {

  }

  return fd
}
